export default function vxDateFormat(moment, amMoment, angularMomentConfig) {
  function amDateFormatFilter(value, format, inputFormat, preprocess) {

    if (typeof value === 'undefined' || value === null) {
      return '';
    }

    var date = moment(value, inputFormat);
    if (!date.isValid()) {
      return '';
    }

    return date.format(format);
  }

  amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;

  return amDateFormatFilter;
}
